import React, { FC, useCallback, useState } from 'react';
import { Button, Select, Space, Tag, Tooltip } from 'antd';
import Title from 'antd/lib/typography/Title';
import { LeftOutlined, PlusOutlined, RightOutlined } from '@ant-design/icons';
import './MultipleToggle.less';

type ItemToggleProps = {
  data: any[];
  value?: number[];
  onChange?: (value?: number[]) => void;
};

const MultipleToggle: FC<ItemToggleProps> = (props) => {
  const [value, setValue] = useState<number[]>(props?.value ?? []);
  const [cycleToggleVisible, setCycleToggleVisible] = useState<boolean>(
    (props?.value?.length ?? 0) <= 1,
  );

  const onchangeSelect = useCallback(
    (item: number[]) => {
      setValue(item);
      props.onChange?.(item);
      if (item.length <= 1) {
        setCycleToggleVisible(true);
      }
    },
    // eslint-disable-next-line
    [props.onChange],
  );

  return (
    <>
      {cycleToggleVisible ? (
        <>
          {props.data.length !== 0 && (
            <Space style={{ paddingBottom: 10 }} size={0}>
              <Tooltip title="Go to previous cycle">
                <Button
                  // type="primary"
                  shape="circle"
                  onClick={() => {
                    if (props.value && props.data.findIndex((e) => props.value == e.id) > 0) {
                      props.onChange?.([
                        props.data[props.data.findIndex((e) => props.value == e.id) + -1].id,
                      ]);
                    }
                  }}>
                  <LeftOutlined />
                </Button>
              </Tooltip>
              <Select
                bordered={false}
                showArrow={false}
                value={props?.value?.[0]}
                onChange={(e) => props.onChange?.(e ? [e] : undefined)}
                style={{ width: 'auto' }}>
                {props.data.map((value) => (
                  <Select.Option key={value.id!} value={value.id!}>
                    <>
                      <Tooltip
                        title={`(${value.startDate?.replace(/-/g, '/')} - ${value.endDate?.replace(
                          /-/g,
                          '/',
                        )})`}>
                        <Tag color="#108ee9" style={{ borderRadius: 15, margin: 0 }}>
                          <Title level={5} style={{ color: 'white', margin: 0 }}>
                            {value.name}
                          </Title>
                        </Tag>
                      </Tooltip>
                    </>
                  </Select.Option>
                ))}
              </Select>
              <Tooltip title="Go to next Cycle">
                <Button
                  // type="primary"
                  shape="circle"
                  onClick={() => {
                    if (
                      props.value &&
                      props.data.findIndex((e) => props.value == e.id) < props.data.length - 1
                    ) {
                      props.onChange?.([
                        props.data[props.data.findIndex((e) => props.value == e.id) + 1].id,
                      ]);
                    }
                  }}>
                  <RightOutlined />
                </Button>
              </Tooltip>
            </Space>
          )}
          {props.data.length > 1 && (
            <div style={{ paddingLeft: '20px' }}>
              <Button
                onClick={() => setCycleToggleVisible(false)}
                type="primary"
                shape="circle"
                icon={<PlusOutlined />}
              />
            </div>
          )}

          <div></div>
        </>
      ) : (
        <div style={{ margin: 10, width: '100%' }}>
          <Select
            mode="multiple"
            showArrow
            // style={{ width: '100%' }}
            className={'selectSection'}
            value={isNaN(value?.[0]) ? props.value : value}
            bordered={true}
            onChange={(e) => onchangeSelect(e)}>
            {props.data.map((value) => (
              <Select.Option key={value.id!} value={value.id!}>
                <>
                  <Tag color="#108ee9" style={{ borderRadius: 15, margin: 0 }}>
                    <Title level={5} style={{ color: 'white', margin: 0 }}>
                      {value.name}
                    </Title>
                  </Tag>
                </>
              </Select.Option>
            ))}
          </Select>
        </div>
      )}
    </>
  );
};

export default MultipleToggle;
